// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"02a22743","457":"8b0f0417","617":"cc0653dd"}[chunkId] + ".chunk.js";
};